import type { ProfileResponse } from '~/models/profile';

export const profileService = {
  /**
   * Fetches the profile information for the current admin user.
   * @param params.organization_id - (Optional) This parameter is required for system managers to retrieve organization-specific data.
   * @returns
   */
  async fetchProfile(params: { organization_id?: number }): Promise<ApiResult<ProfileResponse>> {
    return useMyFetch<ProfileResponse>('/api/v1/admin/profile', {
      method: 'GET',
      params: params,
    });
  },
};
